import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase/firebase';

/**
 * Send a notification to the buyer
 * @param {string} buyerId - User ID of the buyer
 * @param {string} title - Notification title
 * @param {string} body - Notification body
 * @param {Object} data - Additional data (e.g., orderId, type)
 */
const sendNotification = async (buyerId, title, body, data = {}) => {
  if (!buyerId) {
    console.warn("Cannot send notification: No buyerId provided");
    return;
  }

  try {
    const notificationsRef = collection(db, 'notifications');
    await addDoc(notificationsRef, {
      userId: buyerId,
      title,
      body,
      data,
      read: false,
      createdAt: serverTimestamp(),
      type: data.type || 'order_update'
    });
    console.log(`Notification sent to ${buyerId}: ${title}`);
  } catch (error) {
    console.error("Error sending notification:", error);
    // Don't throw, as this is a side effect
  }
};

export const notifyBuyerOrderConfirmed = async (orderId, buyerId) => {
  await sendNotification(
    buyerId,
    "Order Confirmed",
    `Your order #${orderId} has been confirmed and is being processed.`,
    { orderId, type: 'order_status' }
  );
};

export const notifyBuyerOrderShipped = async (orderId, buyerId, trackingData) => {
  const { courier, trackingId, trackingUrl } = trackingData || {};
  let trackingInfo = '';
  
  if (trackingUrl) {
    trackingInfo = ` Track here: ${trackingUrl}`;
  } else if (trackingId) {
    trackingInfo = ` Tracking: ${courier} (${trackingId})`;
  }
  
  await sendNotification(
    buyerId,
    "Order Shipped",
    `Your order #${orderId} has been shipped.${trackingInfo}`,
    { 
      orderId, 
      type: 'order_status',
      trackingId,
      courier,
      trackingUrl
    }
  );
};

export const notifyBuyerOrderDelivered = async (orderId, buyerId) => {
  await sendNotification(
    buyerId,
    "Order Delivered",
    `Your order #${orderId} has been delivered. Enjoy your purchase!`,
    { orderId, type: 'order_status' }
  );
};

export const notifyBuyerOrderCancelled = async (orderId, buyerId) => {
  await sendNotification(
    buyerId,
    "Order Cancelled",
    `Your order #${orderId} has been cancelled.`,
    { orderId, type: 'order_status' }
  );
};
